import { useEffect, useState } from 'react';

import { getColoringGridById } from '../../../../../../../services/api/colloringGridApi';
import { ColoringGridDTO } from '../../../../../../../types/DTO/ColoringGridDTO';

export type useGameEventParams = {
  coloringGridId: string;
};

const useColoringGrid = ({
  coloringGridId,
}: useGameEventParams): { coloringGrid: ColoringGridDTO | null; isLoading: boolean } => {
  const [coloringGrid, setColoringGrid] = useState<ColoringGridDTO | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      setColoringGrid(null);
      if (coloringGridId) {
        setLoading(true);

        const coloringGrid = await getColoringGridById(coloringGridId);
        if (coloringGrid) {
          setColoringGrid(coloringGrid);
        }
      }

      setLoading(false);
    })();
  }, [coloringGridId]);

  return {
    isLoading,
    coloringGrid,
  };
};

export default useColoringGrid;
